<fng-loading-indicator size="large"/>
